<div class="alert-banner">
  @for (alert of siteAlerts$ | async; track alert) {
    <div class="alert alert-item my-3 text-center" role="alert">
      @if (alert.link) {
        <a href="{{alert.link}}" target="_blank">
          <div><fa-icon [icon]="faBell"></fa-icon>&nbsp;<span>{{alert.bannerText}}</span></div>
        </a>
      }
      @if (!alert.link) {
        <div><fa-icon [icon]="faBell"></fa-icon>&nbsp;<span>{{alert.bannerText}}</span></div>
      }
      <!--<a *ngIf="!alert.link && alert.html" (click)="onAlertClick(alert)">
      <div class=""><fa-icon [icon]="faBell"></fa-icon>&nbsp;<span>{{alert.bannerText}}</span></div>
    </a>-->
  </div>
}
</div>

